<template>
  <div>
    <multiselect
      v-model="selected1"
      @input="input"
      :multiple="true"
      :options="managers"
      track-by="user_id"
      :custom-label="customLabel"
      :show-labels="false"
      :searchable="false"
      :allow-empty="true"
      :placeholder="$t('info')"
    >
      <template slot="option" slot-scope="props">{{ props.option.last_name }} {{ props.option.name }}</template>
    </multiselect>
  </div>
</template>

<i18n>
{
  "en": {
    "info": "Select reviewers"
  },
  "ru": {
    "info": "Выберите рецензентов"
   }
}
</i18n>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "select_managers",
  components: {
    Multiselect,
  },
  props: ["managers", "selected", "user_id"],
  data() {
    return {
      selected1: [],
    };
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    managers: "fetchData",
  },
  methods: {
    input(value) {
      this.$http
        .post(
          "admin/users/managers-update?user_id=" + this.user_id,
          value.map(function (value) {
            return value.user_id;
          })
        )
        .then(() => {
          // JSON responses are automatically parsed.
          this.$snotify.success("Успешно!", "Изминения сохранены!", {
            timeout: 500,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            position: "rightTop",
          });
        })
        .catch((e) => {
          this.$snotify.warning(e, "Возникла ошибка!", {
            timeout: 500,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            position: "rightTop",
          });
        });
    },
    customLabel({ last_name, name }) {
      return `${last_name} ${name}`;
    },
    fetchData() {
      var vm = this;
      this.selected1 = this.selected.map(function (value) {
        return vm.managers.find((el) => el.user_id == value.manager_id);
      });
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
